import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import InputType from '../../../shared/enums/input-type.enums';
import { FormsModule } from '@angular/forms';
import ViewportType from '../../../shared/enums/viewport-type.enums';

@Component({
  selector: 'hdi-input',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class InputComponent {
  protected readonly InputType = InputType;

  @Input() viewport: ViewportType = ViewportType.desktop;

  @Input() type: InputType = InputType.Default;
  @Input() name: string = '';
  @Input() placeholder: string = 'placeholder';
  @Input() value: string = '';
  @Input() dataSearchInput?: string = '';
  @Input() required: boolean = false;
  @Input() class: string = '';
  @Input() autocomplete: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inpage: boolean = false;
  @Input() hasError: boolean = false;
  @Output() handleInputChange = new EventEmitter<string>();
  @ViewChild('nativeInput', { static: true })
  nativeInput!: ElementRef<HTMLInputElement>;

  get input(): HTMLInputElement {
    return this.nativeInput.nativeElement;
  }

  inputValue: string = '';

  getAutocomplete = (): string => {
    if (this.type === InputType.Search || this.type === InputType.Default) {
      return 'on';
    }
    return 'off';
  };

  inputChange(event: string) {
    this.handleInputChange.emit(event);
  }
}
